import { QUERIES } from '@repo/ui/queries';
import styled from 'styled-components';

export const TwoRowsContainer = styled.div`
  display: flex;
  flex-direction: column;

  gap: 48px;

  ${QUERIES.largeTabletAndUp} {
    display: grid;

    grid-template-columns: repeat(2, 1fr);

    align-items: center;
  }
`;
